import { Component } from '@angular/core';
import {
  GedBaseComponent,
  IGedBaseComponent,
} from '../../../../../../core/base/components/ged-base/ged-base.component';
import { FeiColumn } from '../../../../../../core/base/interfaces/fei-column.interface';
import { AuthService } from '../../../../../../core/services/auth.service';
import { GedService } from '../../../../admin/playground/docuware-playground/ged.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { FileSaverService } from 'ngx-filesaver';
import { GED_CONFIG } from '../../../../../../core/enums/ged-type.enum';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SupplierService } from '../../supplier.service';
import { SupplierModel } from '../../../../../../core/models/supplier.model';
import { ENUM_PERMISSIONS } from '../../../../../../core/enums/permission.enum';

@Component({
  selector: 'vex-supplier-details-documents',
  templateUrl: './supplier-details-documents.component.html',
  styleUrls: ['./supplier-details-documents.component.scss'],
})
export class SupplierDetailsDocumentsComponent extends GedBaseComponent<SupplierModel> implements IGedBaseComponent {
  documentTypes = ['KBIS', 'RIB', 'Autres'];
  feisColumns: Array<FeiColumn> = [
    { label: 'Nom du fichier', column: 'NOM_DU_DOCUMENT' },
    { label: 'Type de document', column: 'DOCUMENT_TYPE' },
    { label: 'Nombre de pages', column: 'DWPAGECOUNT' },
    { label: 'Date du dépôt', column: 'DATE_DU_DEPOT', type: 'date' },
    { label: '', column: 'btnToPrev', type: 'custom' },
    {
      label: '',
      column: 'actions',
      canUpdate: false,
      // Alignement convention GED PRED-3128 : suppression de document → DELETE_SUPPLIER (comme le back).
      canDelete: this.authService.hasPermission(ENUM_PERMISSIONS.DELETE_SUPPLIER),
      canDownload: this.authService.hasPermission(ENUM_PERMISSIONS.READ_SUPPLIER),
    },
  ];
  displayedColumns = [];

  constructor(
    public service: SupplierService,
    public authService: AuthService,
    private gedService: GedService,
    public dialog: MatDialog,
    public fileSaver: FileSaverService,
  ) {
    super(GED_CONFIG.supplier, gedService, service, dialog, fileSaver);
    this.displayedColumns = this.feisColumns.map(x => x.column);
  }

  initForm() {
    this.form = new UntypedFormGroup({
      documentType: new UntypedFormControl(null, [Validators.required]),
      predikId: new UntypedFormControl(this.id, [Validators.required]),
    });
    this.loading = false;
  }
}
